import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/usr/src/app/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/(auth)/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"display\":\"swap\",\"weight\":\"400\",\"variable\":\"--font-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"InterFont\"}");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/crm-app/src/style/App.css");
